import { useEffect, useState } from 'react'

const secondsSince = (startedAt: number) => Math.max(0, Math.floor((Date.now() - startedAt) / 1000))

export const useElapsedSeconds = (startedAt: number): number => {
  const [seconds, setSeconds] = useState(() => secondsSince(startedAt))

  useEffect(() => {
    const id = setInterval(() => setSeconds(secondsSince(startedAt)), 1000)
    return () => clearInterval(id)
  }, [startedAt])

  return seconds
}
